import React from 'react';
import { ReactComponent as Error404 } from '../svg/404-error.svg';

import { Container, Paper, Typography, SvgIcon } from '@material-ui/core';
import { useNotFoundPageStyles } from '../styles/muiStyles';

const NotFoundPage = () => {
  const classes = useNotFoundPageStyles();

  return (
    <Container disableGutters>
      <Paper variant="outlined" className={classes.mainPaper}>
        <div className={classes.textWrapper}>
            <Error404 />
          <Typography color="secondary" variant="h4">
            404 | Page Not Found
          </Typography>
          <Typography color="secondary" variant="h6">
            how did you end up here 🤔
          </Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;
